import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-reset-search",
  "use": "icon-reset-search-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\" id=\"icon-reset-search\"><path d=\"M13.03 12.125a6.784 6.784 0 0 0 1.595-4.375A6.868 6.868 0 0 0 2.75 3.041V.25H1.5v5h5V4H3.583A5.61 5.61 0 1 1 2.27 9H.995a6.883 6.883 0 0 0 6.755 5.625c1.601.001 3.15-.564 4.375-1.595l4.741 4.72.884-.884-4.72-4.741Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol